import React from 'react';
import _ from 'lodash';
import { makeStyles } from '@mui/styles';

import classnames from 'classnames';

import withRouter from '../../../components/hocs/withRouter';

const Step = ({ active = false, children, complete = false }: any) => {
  const itemClasses = classnames({
    active: !!active,
    complete: !!complete,
  });

  return <li className={itemClasses}>{children}</li>;
};

export const QuoteStepsP100 = withRouter(({ location, agencyBilled }: any) => {
  const classes = useStyles();
  const screen = location.pathname.split('/')[4];

  return (
    <ol className={`list--unstyled ${classes.list}`}>
      <Step
        active={screen === 'approve'}
        complete={['attest', 'pay'].indexOf(screen) !== -1}
      >
        1. Approve
      </Step>
      <Step
        active={screen === 'attest'}
        complete={['pay'].indexOf(screen) !== -1}
      >
        2. Attest
      </Step>
      {!_.isUndefined(agencyBilled) && !agencyBilled && (
        <Step active={screen === 'pay'}>3. e-Pay</Step>
      )}
    </ol>
  );
});

export const QuoteStepsP250 = withRouter(({ location, agencyBilled }: any) => {
  const classes = useStyles();
  const screen = location.pathname.split('/')[4];

  return (
    <ol className={`list--unstyled ${classes.list}`}>
      <Step
        active={screen === 'approve'}
        complete={['attest', 'sign', 'pay'].indexOf(screen) !== -1}
      >
        1. Approve
      </Step>
      <Step
        active={screen === 'attest'}
        complete={['sign', 'pay'].indexOf(screen) !== -1}
      >
        2. Attest
      </Step>
      <Step active={screen === 'sign'} complete={screen === 'pay'}>
        3. e-Sign
      </Step>
      {!_.isUndefined(agencyBilled) && !agencyBilled && (
        <Step active={screen === 'pay'}>4. e-Pay</Step>
      )}
    </ol>
  );
});

const useStyles = makeStyles(({ config, palette }) => ({
  list: {
    display: 'flex',
    marginBottom: '1.3333333333rem !important',

    '& li': {
      marginRight: '2rem',
      fontSize: config.textSizes.paragon,
    },

    '& li.active': {
      position: 'relative',
      color: palette.text.link,
      fontWeight: 600,

      '&:before': {
        content: '""',
        width: '100%',
        height: 2,
        position: 'absolute',
        bottom: -2,
        left: 0,
        background: palette.common.cowbellBlue,
      },
    },

    '& li.complete': {
      color: palette.common.cowbellBlue,
    },
  },
}));
